export class SnapshotModel {
  public participants: number;
  public completed: number;
  public start_date: Date;
  public end_date: Date;
}
